import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import BOSForm from "../../components/BOSForm";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
import { logout } from "../../Helpers";

export default function BOSPanelFormFill() {

    const [fetching, setFetching] = useState(true);
    useEffect(() => {
        if (Cookies.get("username") === undefined) {
            alert("unauthorized to this page")
            logout("/bospanel-login");
            return;
        }
        setFetching(false);
    }, []);

    return (
        <>
            {!fetching && <BOSForm subjectFromPrev={Cookies.get("username")} viewMode={false} />}
        </>
    )

}
